import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { BucketExplorerPage } from '@/features/data/buckets/bucket-explorer-page';
import { normalizePrefix } from '@/features/data/buckets/bucket-paths';
import { isBucketTab, type BucketTab } from '@/features/data/buckets/bucket-types';
import { ConsoleShell } from '@/features/shell/console-shell';

/**
 * Onglet actif ET dossier courant dans l'URL (`?tab=files&path=raw/eco2mix/`) : un lien ou une
 * capture pointe sur un dossier précis, et le bouton Précédent du navigateur remonte d'un niveau.
 */
export const Route = createFileRoute('/$tenant/buckets/$bucketId')({
  validateSearch: (search: Record<string, unknown>): { tab: BucketTab; path: string } => ({
    tab: isBucketTab(search['tab']) ? search['tab'] : 'files',
    path: normalizePrefix(typeof search['path'] === 'string' ? search['path'] : ''),
  }),
  component: BucketRoute,
});

function BucketRoute() {
  const { tenant, bucketId } = Route.useParams();
  const { tab, path } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();

  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="buckets"
      crumbs={[{ label: t('nav.items.buckets') }, { label: bucketId, mono: true }]}
    >
      <BucketExplorerPage
        tenantId={tenant}
        bucketId={bucketId}
        tab={tab}
        path={path}
        onTabChange={(next) => void navigate({ search: { tab: next, path }, replace: true })}
      />
    </ConsoleShell>
  );
}
